export default __webpack_public_path__ + "static/media/Top 50 logo-01.782451c7.svg";